"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_INVOICE_SCOLAPASS_FILE = void 0;
const client_1 = require("@apollo/client");
exports.GET_INVOICE_SCOLAPASS_FILE = client_1.gql `
  query getPDFFile($fileName: String!) {
    getPDFFile(fileName: $fileName)
  }
`;
